/* @ngInject */
export function Service ($resource, modelConfig) {
	return $resource(modelConfig.defaults.serviceBaseUrl + '/:resource/:funcName', {
		resource: '@resource', funcName: ''
	}, {});
}
